import { createSlice } from "@reduxjs/toolkit";
// this code for slice value for   Redisvalues
export const Redisvalues = createSlice({
  name: "Redisvalues",
  initialState: {
    api_completed: false,
    isLoading: false,
    isSuccess: false,
    switch: false,
    data: {},
  },
  reducers: {
    Redisvalues_datagrid: (state, a) => {
      state.data = a.payload;
      state.switch = true;
    },
    success_api_call_Redisvalues_datagrid: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
      state.isSuccess = true;
      state.api_completed = true;
    },
    failure_api_call_Redisvalues_datagrid: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
      state.isSuccess = false;
      state.api_completed = true;
    },
    Redisvalues_datagrid_is_success: (state, action) => {
      state.isSuccess = false;
    },
    create_Redisvalues_datagrid_complete_api: (state, action) => {
      state.api_completed = false;
    },
    false_switchRedisvalues: (state) => {
      state.switch = false;
    },
  },
});
export default Redisvalues.reducer;
export const {
  Redisvalues_datagrid,
  success_api_call_Redisvalues_datagrid,
  failure_api_call_Redisvalues_datagrid,
  create_Redisvalues_datagrid_complete_api,
  Redisvalues_datagrid_is_success,
  false_switchRedisvalues,
} = Redisvalues.actions;
